import {validate} from 'jquery-validation'; // https://jqueryvalidation.org/documentation/
import 'jquery-validation/dist/additional-methods'; // enable check for file extension

/**
 * Extends the jquery-validation plugin to show the errors in the
 * right location in our theme
 */
export class FormValidator {

    constructor($form = null) {
        this.$form = $form;
        this.$errorContainer = $('.c-form-page__validation-error');
        this.$errorTitle = this.$errorContainer.find('.c-form-page__validation-title');
        this.$errorList = this.$errorContainer.find('.c-form-page__validation-list');

        const checkEmailRemote = {
            url: wp.ajaxurl,
            type: "post",
            data: {
                action: 'edpress_action',
                service: 'BijlesnetwerkApiService',
                method: 'checkIfEmailNotExists',
                nonce: wp.ajax_nonce
            }
        };

        this.addValidationMethods();

        /** the validate function returns a Validator object
         *  store this in the check property so we can access
         *  this from other components
         */
        if($form) {
            this.check = $form.validate({
                rules: {
                    "gradesFile": {
                        maxSize: 8,
                        extension: "pdf|jpeg|jpg|docx|bmp|png|gif|doc"
                    },
                    "course_ids[]": {
                        atLeastOneChecked: true,
                    },
                    "person_email1": {
                        required: true,
                        email: true,
                        remote: checkEmailRemote
                    },
                    "student_email1": {
                        emailaddress: true
                    },
                    "person_email1" : {
                        emailaddress: true,
                        remote: checkEmailRemote
                    },
                    "email1": {
                        emailaddress: true,
                        remote: checkEmailRemote
                    },
                    "phone1" : { phone: true },
                    "phone2" : { phone: true },
                    "person_phone1" : { phone: true },
                    "student_phone1" : { phone: true },
                    "student_address_postalCode" : { zipcode: true },
                    "person_postalCode" : { zipcode: true },
                    "postalCode" : { zipcode: true }
                },
                messages: {
                    "course_ids[]": "Selecteer minimaal één vak",
                    "educationStartYear": "Het opgegeven startjaar is geen geldig jaartal",
                    "email1": {
                        email: 'Het opgegeven e-mailadres is niet geldig',
                        remote: 'Het opgegeven e-mailadres is reeds bij ons bekend. Stuur een e-mail aan werken@bijlesnetwerk.nl met de relevante sollicitatiegegevens om de sollicitatie rond te maken.'
                    },
                    "person_email1": {
                        email: 'Het opgegeven e-mailadres is niet geldig',
                        remote: 'Het opgegeven e-mailadres is reeds bij ons bekend. Log in met uw e-mailadres. Eventueel kunt u uw wachtwoord resetten'
                    },
                    "gradesFile" :{
                        maxSize : "De cijferlijst heeft een maximale grootte van {0} mb",
                        extension : "Alleen .pdf, .jpeg, .jpg, .docx, .bmp, .png, .gif en .doc bestanden zijn toegestaan."
                    }
                },
                errorClass: "js-invalid",
                errorPlacement:  /* istanbul ignore next */ (error, element) => {
                    this.errorPlacement(error, element)
                },
                invalidHandler: /* istanbul ignore next */ (event, validator) => {
                    // istanbul ignore next
                    this.onFormInvalid(event, validator)
                },
                submitHandler: /* istanbul ignore next */ (form) => {
                    this.onFormSubmit(form)
                }
            });
        }
    }


    addValidationMethods() {
        /* istanbul ignore next */
        $.validator.addMethod(
            'atLeastOneChecked',
            (value, element) => this.validateCheckboxGroup(value, element),
            'Selecteer minimaal één veld'
        );

        /* istanbul ignore next */
        $.validator.addMethod(
            'emailaddress',
            email => this.validateEmailAddress(email),
            'Het opgegeven e-mailadres is niet geldig'
        );

        /* istanbul ignore next */
        $.validator.addMethod(
            'phone',
            number => this.validateDutchPhoneNumber(number),
            'Het opgegeven telefoonnummer is niet geldig'
        );

        /* istanbul ignore next */
        $.validator.addMethod(
            'zipcode',
            zipcode => this.validateDutchZipcode(zipcode),
            'De opgegeven postcode is niet geldig'
        );

        /* istanbul ignore next */
        $.validator.addMethod(
            'maxSize',
            (value, element, param) => this.validateMaxFileSize(value, element, param),
            'Het opgegeven bestand is te groot');
    }

    /**
     * docs: https://stackoverflow.com/questions/33096591/validate-file-extension-and-size-before-submitting-form
     * @param value
     * @param element
     * @param param
     * @returns {*|boolean}
     */
    validateMaxFileSize(value, element, param) {
        const maxSize = param * 1000 * 1000;
        if(!element || !element.files[0]) return true;
        return element.files[0].size <= maxSize;
    }

    validateCheckboxGroup(value, element) {
        return $(`[name="${element.name}"]:checked`).length > 0;
    }

    validateEmailAddress(email) {
        if (email.length === 0) return true;
        const regex = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
        return regex.test(email);
    }

    validateDutchPhoneNumber(number) {
        if (number.length === 0) return true;
        const phone = /^(((0)[1-9]{2}[0-9][-]?[1-9][0-9]{5})|((\\+31|0|0031)[1-9][0-9][-]?[1-9][0-9]{6}))$/;
        const mobile = /^(((\+31|0|0031)6){1}[1-9]{1}[0-9]{7})$/i;
        return (phone.test(number) || mobile.test(number));
    }

    validateDutchZipcode(zipcode) {
        const regex = /^[1-9][0-9]{3}\s?[A-Za-z]{2}$/i;
        return regex.test(zipcode);
    }

    onFormInvalid(e, validator) {
        this.$errorList.html('');
        $('html, body').animate({scrollTop : 0}, {
            duration: 500, queue: false
        });

        let errors = validator.numberOfInvalids();
        if (errors) {
            if (1 == errors) {
                this.showError('Je hebt 1 veld niet of fout ingevuld, deze is beneden uitgelicht.');
            } else {
                this.showError(`Je hebt ${errors} velden niet of fout ingevuld, deze worden beneden uitgelicht.`);
            }
        } else {
            this.hideErrors();
        }
    }

    errorPlacement(error) {
        const $error = error[0];
        const $shownErrors = this.$errorList.find('li');
        const msg = $error.innerHTML;
        let errorStrings = [];

        // add already visible errors to errorString array
        for (const $shownError of $shownErrors) {
            errorStrings.push($shownError.innerHTML);
        }

        // ignore duplicate errors
        // invalidHandler already describes required fields so don't show this error
        if (errorStrings.indexOf(msg) === -1 && 'This field is required.' !== msg) {
            errorStrings.push(msg);
            $(`<li>${msg}</li>`).appendTo(this.$errorList);
        }
    }

    onFormSubmit(form) {
        $('[type="submit"]').append('<i class="fa fa-spinner fa-spin"></i>');
        form.submit();
    }

    showError(message) {
        this.$errorTitle.html(message);
        this.$errorContainer.show();
    }

    hideErrors() {
        this.$errorTitle.html('');
        this.$errorList.html('');
        this.$errorContainer.hide();
        this.$form.find('.js-invalid').removeClass('js-invalid');
    }
}
